<template>
<popup :showFlag="showFlag"
       @onShowpop="onShowpop"
       :mask="false">
    <div class="colorwrap">
        <color-sel :color="color"
                   :coloridx="coloridx"
                    @onSetidx="onSetidx"></color-sel>
    </div>
    <duicuo @onCancel="onCancel"
            @onOk="onOk">
        <div class="info">选择底色</div>
    </duicuo>
</popup>
</template>

<script>
import popup from '@/components/popup'
import colorSel from '@/components/colorSel/colorSel'
import duicuo from '@/components/duicuo/duicuo'
export default {
  name: 'changeColor',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    },
    color: {
      default: () => [],
      type: Array
    },
    coloridx: {
      default: 0,
      type: Number
    }
  },
  methods: {
    onShowpop () {
      this.$emit('onControlColor')
    },
    onSetidx (idx) {
      this.$emit('onSetidx', idx)
    },
    onCancel () {
      this.$emit('onSetidx', 0)
      this.$emit('onControlColor')
    },
    onOk () {
      this.$emit('onControlColor')
    }
  },
  components: {
    popup,
    colorSel,
    duicuo
  }
}
</script>

<style scoped>
.colorwrap{
  background-color: #F7F7F7;
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  padding:.54rem 0;
  box-shadow: 0 0 .4rem rgba(0,0,0,0.2);
}
.info{
  font-size: .28rem;
  color:#303133;
}
</style>
